module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/item-9-475c2de85655e5587f39fee5c4d1c104.jpg";